import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { SVButton } from '@/components/core';
import { useVerifyApplicationExternalAccounts } from '@/hooks/requests/useBankApplications';
import showToast from '@/utils/toast';
import { MESSAGES } from '@/constants/messages';

type BankApplicationVerifyExternalAccountsDialogProps = {
  uuid: string;
  applicationId: string;
  ownerName: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  navigateRoute?: string;
};

export default function BankApplicationVerifyExternalAccountsDialog({
  uuid,
  applicationId,
  ownerName,
  open,
  setOpen,
}: BankApplicationVerifyExternalAccountsDialogProps) {
  const {
    verifyApplicationExternalAccounts,
    isVerifyApplicationExternalAccounts,
  } = useVerifyApplicationExternalAccounts();

  async function handleConfirm() {
    try {
      await verifyApplicationExternalAccounts(uuid);
      showToast({
        type: 'success',
        data: {
          content:
            'External Accounts associated to bank account application have been successfully verified',
        },
      });
      setOpen(false);
    } catch {
      showToast({
        type: 'error',
        data: {
          content: MESSAGES.genericError,
        },
      });
    }
  }

  return (
    <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <Box>
          <Typography variant="h6" component="h2">
            Verify All External Accounts?
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Are you sure you want to verify all the external accounts for "
            {ownerName}" (Application ID: {applicationId})?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <SVButton onClick={() => setOpen(false)} variant="tertiary">
          No, Don't Verify
        </SVButton>
        <SVButton
          onClick={handleConfirm}
          variant="primary"
          isLoading={isVerifyApplicationExternalAccounts}>
          Yes, Verify
        </SVButton>
      </DialogActions>
    </Dialog>
  );
}
